<div class="grid-1col input-grid-gaps">
    <app-text-input
        [form]="form"
        id="name"
        [prefix]="prefix"
    ></app-text-input>

    <app-number-input
        [form]="form"
        id="daysToProcess"
        [prefix]="prefix"
    ></app-number-input>

    <app-check-input
        [form]="form"
        id="active"
        [prefix]="prefix"
    ></app-check-input>
</div>


